import { Typography } from '@mui/material';
import React from 'react';

import i18n from 'FRONTEND/utils/i18n';

// Error boundaries only work as class components
const ErrorFallback = ({ maxWidth = '100%' }) => {
  return (
    <Typography sx={{ maxWidth }} variant='subtitle2'>{i18n._('An error occurred. Please retry later.')}</Typography>
  );
};

export default ErrorFallback;
